import { getDisplayDate } from 'src/utils/dateUtils';

const DATE_STRING_PATTERN = /^\d{4}[-/]\d{2}[-/]\d{2}(?:[T\s].*)?$/;

export const formatPopupDate = (value, format, useShortYear = false) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    if (value instanceof Date || (typeof value === 'string' && DATE_STRING_PATTERN.test(value))) {
        const parsedDate = value instanceof Date ? value : new Date(value);
        if (!Number.isNaN(parsedDate.getTime())) {
            if (useShortYear) {
                const locale = localStorage.getItem('languageISOCode');
                return parsedDate.toLocaleDateString(
                    locale && locale !== 'undefined' ? locale : 'en-US',
                    { year: '2-digit', month: 'numeric', day: 'numeric' }
                );
            }
            return getDisplayDate(parsedDate, format);
        }
    }

    return String(value);
};
